/** @file Thai catalog part of area E9 (W3-03), partial; replaced whole by that area. */

/** The `psdImport` and `autorig` blocks (spread at the top level); partial, English fills the gaps. S0 composes it into `th`. */
export const autorigPanelTh = {
  psdImport: {
    choosePsd: 'นำเข้า PSD…', choosePngs: 'เพิ่มรูป PNG…', newFromPsd: 'สร้างโปรเจกต์จาก PSD…',
    titlePsd: 'นำเข้า layer จาก PSD', titlePng: 'นำเข้ารูป PNG', reading: 'กำลังอ่าน {file}…', projectName: 'ชื่อโปรเจกต์',
    layers: 'Layer เรียงจากล่างขึ้นบน', size: '{w} × {h} px ที่ {x}, {y}', hidden: 'ซ่อนอยู่ใน PSD', x: 'x', y: 'y',
    place: 'วางตำแหน่งรูป (ระยะเป็นพิกเซลจากมุมซ้ายบน)', preview: 'ตัวอย่างการวางตำแหน่ง',
    notes: 'หมายเหตุ ({n})', more: '… และอีก {n} รายการ', start: 'นำเข้า {n} layer', uploading: 'กำลังอัปโหลด {done} จาก {total}…',
    done: 'นำเข้าแล้ว {n} รูป (rev {rev})', failed: 'การนำเข้าหยุดหลังอัปโหลดได้ {done} จาก {total}',
    retry: 'ลองส่วนที่เหลืออีกครั้ง', close: 'ปิด',
    nextAutorig: 'ขั้นต่อไป: เปิดแผง {panel} แล้วเรียก “{action}” เพื่อสร้างกระดูก สล็อต และ region จาก layer เหล่านี้',
  },
  autorig: {
    title: 'ริกอัตโนมัติ', status: 'รูป {images} · วางตาม PSD {placed} · slot {slots}',
    groupRig: 'ทั้งตัว', groupSkeleton: 'โครงกระดูก', groupParts: 'ชิ้นส่วน', groupAnimate: 'แอนิเมชัน',
    fn: {
      autoRig: 'ริกอัตโนมัติทั้งตัว', suggestSkeleton: 'เสนอโครงกระดูก', detectJoints: 'หาตำแหน่งข้อต่อ',
      inferDrawOrder: 'เดาลำดับการวาด', suggestIk: 'เสนอ IK', checkMirrorAsymmetry: 'ตรวจความไม่สมมาตรซ้าย-ขวา',
      autoMesh: 'สร้าง mesh อัตโนมัติ', autoWeights: 'ลงน้ำหนักอัตโนมัติ', suggestHandle: 'เสนอจุดจับ', suggestGrip: 'เสนอการกำ',
      walkCycle: 'วงจรการเดิน',
    },
    arg: {
      images: 'รูป (ไม่เลือก = ทั้งหมด)', attachment: 'Attachment', bone: 'Bone', bones: 'Bone (ไม่เลือก = ค่าเริ่มต้น)',
      jointHints: 'Bone ที่เป็นข้อต่อ', facing: 'หันไปทาง', method: 'วิธีลงน้ำหนัก', detail: 'ความละเอียด mesh',
      pairs: 'คู่ข้อต่อจาก bone ที่เลือก: {n} (ไม่เลือก = ทุกคู่)', choose: '(เลือก)', auto: 'อัตโนมัติ',
      left: 'ซ้าย', right: 'ขวา', front: 'ด้านหน้า', heat: 'Bone heat', envelope: 'Envelope',
      animation: 'ชื่อแอนิเมชัน (ว่าง = walk)', frames: 'จำนวนเฟรมในหนึ่งรอบ', limbs: 'แขนขา (bone; ไม่เลือก = หาจากชื่อ)',
    },
    analyse: 'วิเคราะห์', running: 'กำลังวิเคราะห์ ({fn})…', failed: 'การวิเคราะห์ล้มเหลว',
    ready: 'แผนพร้อมแล้ว: {commands} คำสั่ง ความมั่นใจ {percent} %',
    applied: 'ใช้แล้วเป็น rev {rev} (ความมั่นใจ {percent} %)', undone: 'ยกเลิก rev {rev} แล้ว',
    stale: 'โปรเจกต์เปลี่ยนไปหลังจากทำแผนนี้ (rev {ifRev} ตอนนี้ {currentRev}) วิเคราะห์ใหม่เพื่อวางแผนบนริกปัจจุบัน',
    reviewTitle: 'ตรวจแผน: {fn}', confidence: 'ความมั่นใจ {percent} % ({band})',
    band: { low: 'ต่ำ', medium: 'ปานกลาง', high: 'สูง' },
    commands: 'คำสั่งที่เสนอ ({n})', warnings: 'หมายเหตุและคำเตือน ({n})', empty: 'การวิเคราะห์นี้ไม่เสนอการเปลี่ยนแปลง',
    rerig: 'โปรเจกต์นี้มีริกอยู่แล้ว (สล็อต {slots}): การใช้แผนนี้จะเปลี่ยนค่าเดิม {n} ค่า (ดูได้จากภาพ ghost และย้อนกลับได้ด้วย Undo)',
    zeroConfidence: 'ความมั่นใจ 0 %: มีอย่างน้อยหนึ่งขั้นตอนที่การวิเคราะห์ไม่พบสิ่งที่เชื่อถือได้ ตรวจคำสั่งและภาพ ghost ก่อนกดใช้ หรือวิเคราะห์ใหม่ด้วยตัวเลือกอื่น',
    ghost: 'แสดงภาพเงาในวิวพอร์ต',
    ghostTooLarge: 'ไม่มีภาพเงา: {n} คำสั่งมากกว่าที่แสดงตัวอย่างได้ ({max}) แต่ยังกดใช้ได้',
    ghostFailed: 'ไม่มีภาพเงา: แผนนี้ใช้กับเอกสารที่เปิดอยู่ไม่ได้',
    ghostOutOfSync: 'ไม่มีภาพเงา: เอกสารที่เปิดอยู่ไม่ใช่ rev ที่ใช้ทำแผนนี้ วิเคราะห์อีกครั้งเพื่อดูภาพเงา',
    apply: 'ใช้ (หนึ่ง commit)', rerun: 'วิเคราะห์อีกครั้ง', close: 'ปิด',
    pivots: 'จุดหมุนที่กำหนดเอง เป็นพิกเซลของ layer (ว่าง = อัตโนมัติ)', pivotSet: 'กำหนด', pivotClear: 'ล้าง',
    pivotX: 'x', pivotY: 'y', pivotAuto: 'อัตโนมัติ', rerunWithPivots: 'วิเคราะห์อีกครั้งด้วยจุดหมุนที่กำหนด',
  },
} as const;
